import React from 'react'

const Footer = () => {
  return (
    <div>
      <footer id="main-footer" className="bg-dark p-4" >
        <p className="text-white" style={{ textAlign: " right" }}>
          Copyright &copy; Dalia Gadelhak
            </p>
      </footer>
    </div>
  )
}

export default Footer
